export default Object.freeze({
  deliveryMethod: {
    name: 'type',
  },
  deliveryAddress: {
    name: 'additionalInformation',
  },
});

export const resolveHardCopy = '1';
export const rejectHardCopy = '2';

export const deliveryMethodMap = {
  [resolveHardCopy]: 'Доставка документов в бумажном виде почтой',
  [rejectHardCopy]: 'Доставка документов в электронном виде через Личный кабинет',
};
